import { render } from "./BulkEdit.vue?vue&type=template&id=85940538"
import script from "./BulkEdit.vue?vue&type=script&lang=js"
export * from "./BulkEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__